<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.visma_settings.form.api_url')"
            :is-required="true"
            :error="errorsData.api_url"
            :hint="__('settings.visma_settings.form.api_url_hint')"
        >
            <DInput
                id="api_url"
                v-model="form.api_url"
                :placeholder="__('settings.visma_settings.form.api_url')"
                :is-valid="isFormFieldValid('api_url')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.visma_settings.form.username')"
            :is-required="true"
            :error="errorsData.username"
            :hint="__('settings.visma_settings.form.username_hint')"
        >
            <DInput
                id="username"
                v-model="form.username"
                :placeholder="__('settings.visma_settings.form.username')"
                :is-valid="isFormFieldValid('username')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.visma_settings.form.password')"
            :is-required="vismaSettings === null"
            :error="errorsData.password"
            :hint="__('settings.visma_settings.form.password_hint')"
        >
            <DInput
                id="password"
                v-model="form.password"
                :placeholder="__('settings.visma_settings.form.password')"
                type="password"
                :is-valid="isFormFieldValid('password')"
                maxlength="255"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.visma_settings.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.visma_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.visma_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            v-if="credentialsValid"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script setup>
import { ref, onUpdated } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

const props = defineProps({
    vismaSettings: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    api_url: props.vismaSettings?.api_url ?? null,
    username: props.vismaSettings?.username ?? null,
    password: props.vismaSettings?.password ?? null
})

const emit = defineEmits(['form-submitted'])

const credentialsValid = ref(false)
const connectionStatus = ref(null)
const errorsData = ref(props.errors)
const connectionException = ref(null)

const submitForm = () => {
    emit('form-submitted', form)
}

onUpdated(() => {
    errorsData.value = props.errors
})

const checkConnection = () => {
    errorsData.value = {}
    connectionException.value = null
    window.axios.post(route('settings.visma-settings.check', form))
        .then(function () {
            connectionStatus.value = 'successful'
            credentialsValid.value = true
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'

            credentialsValid.value = false
            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors

                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        })
}

const closeErrorCheckModal = () => {
    connectionException.value = null
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
